import { getSeatPrice } from './getSeatPrice';
export function getIsFreeSeat(seat) {
    const price = getSeatPrice(seat);
    return price.amount === 0 && !seat.rfisc && seat.isAvailable && seat.isExistent;
}
